const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 7.92969C16.3632 8.22259 16.3632 8.69746 16.0703 8.99035L13.0607 12L16.0703 15.0097C16.3632 15.3026 16.3632 15.7775 16.0703 16.0704C15.7774 16.3632 15.3026 16.3632 15.0097 16.0704L12 13.0607L8.99033 16.0704C8.69744 16.3632 8.22256 16.3632 7.92967 16.0704C7.63678 15.7775 7.63678 15.3026 7.92967 15.0097L10.9393 12L7.92967 8.99035C7.63678 8.69746 7.63678 8.22259 7.92967 7.92969C8.22256 7.6368 8.69744 7.6368 8.99033 7.92969L12 10.9394L15.0097 7.92969C15.3026 7.6368 15.7774 7.6368 16.0703 7.92969Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32967 1.46967C7.47032 1.32902 7.66109 1.25 7.86 1.25H16.14C16.3389 1.25 16.5297 1.32902 16.6703 1.46967L22.5303 7.32967C22.671 7.47032 22.75 7.66109 22.75 7.86V16.14C22.75 16.3389 22.671 16.5297 22.5303 16.6703L16.6703 22.5303C16.5297 22.671 16.3389 22.75 16.14 22.75H7.86C7.66109 22.75 7.47032 22.671 7.32967 22.5303L1.46967 16.6703C1.32902 16.5297 1.25 16.3389 1.25 16.14V7.86C1.25 7.66109 1.32902 7.47032 1.46967 7.32967L7.32967 1.46967ZM8.17066 2.75L2.75 8.17066V15.8293L8.17066 21.25H15.8293L21.25 15.8293V8.17066L15.8293 2.75H8.17066Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.a5eb610b3e10162ed1eea14fe03c1828.svg";
export { ForwardRef as ReactComponent };